import { Steps } from 'antd'
import classNames from 'classnames'

import cn from './AtomSteps.module.scss'

export type AtomStepsOption<T extends string> = {
  value: T
  label: string
}

type AtomStepsProps<T extends string> = {
  options: AtomStepsOption<T>[]
  value: T
  onChange: (value: T) => void
  ariaLabel: string
  isOrganisationSelected?: boolean
  className?: string
}

function AtomSteps<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  isOrganisationSelected = false,
  className,
}: AtomStepsProps<T>) {
  const current = Math.max(
    options.findIndex((option) => option.value === value),
    0
  )

  return (
    <nav aria-label={ariaLabel} className={cn.wrapper}>
      <Steps
        size="small"
        current={current}
        items={options.map((option) => ({ title: option.label }))}
        onChange={(index) => {
          const option = options[index]
          if (option) onChange(option.value)
        }}
        className={classNames(
          cn.steps,
          isOrganisationSelected && cn.accentSelected,
          className
        )}
      />
    </nav>
  )
}

export default AtomSteps
